import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { defer, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class APIRequests {
  axiosConfig: AxiosRequestConfig = {
    baseURL: `https://lk.dalli-service.com`,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  axiosInit = (config: AxiosRequestConfig): AxiosInstance => {
    const axiosInstance = axios.create(config);
    return axiosInstance;
  };

  axiosInstance = this.axiosInit(this.axiosConfig);

  funcGet = (inst: AxiosInstance, url: string, queryParams?: object) => {
    return defer(() => inst.get(url, { params: queryParams })).pipe(map((result) => result.data));
  };

  get = <T>(url: string, queryParams?: object): Observable<T> => {
    return this.funcGet(this.axiosInstance, url, queryParams);
  };

  //-----------------------------------------------------------------------------

  getYmaps = () => this.get<any>('/json/getpvzlistforyamap.php?get=true');
}

export const APIYmaps = new APIRequests();
